const defaultRegion = 'CN';
const vietnamRegion = 'VN';
const regionStorageKey = 'region';
const regionCodePattern = /^[A-Z]{2}$/;

function regionFromHostname(hostname: string): string {
  const labels = hostname.trim().toLowerCase().split(':')[0].split('.').filter(Boolean);
  if (labels.includes('vn') || labels.includes('vietnam')) return vietnamRegion;
  return defaultRegion;
}

export function resolveRegisterRegion(hostname = window.location.hostname): string {
  return regionFromHostname(hostname);
}

export function readUserRegion(): string | null {
  try {
    const value = localStorage.getItem(regionStorageKey)?.trim().toUpperCase() ?? '';
    return regionCodePattern.test(value) ? value : null;
  } catch {
    return null;
  }
}

/** 请求必带的 region：已保存的用户地区优先，否则按当前域名解析 */
export function resolveRequestRegion(): string {
  return readUserRegion() ?? resolveRegisterRegion();
}

export function saveUserRegion(region: string) {
  const code = region.trim().toUpperCase();
  if (!regionCodePattern.test(code)) return;
  try {
    localStorage.setItem(regionStorageKey, code);
    const raw = localStorage.getItem('user');
    if (!raw) return;
    const user = JSON.parse(raw) as Record<string, unknown>;
    if (!user || typeof user !== 'object') return;
    user.region = code;
    localStorage.setItem('user', JSON.stringify(user));
  } catch {
    // 本地存储不可用时，请求头仍然会带上本次解析出的地区
  }
}
